import { uniqueByField } from '@/utils';

function mapOptions(payload) {
  return uniqueByField(payload, 'valor')
    .map((option) => {
      let extra;
      try {
        extra = JSON.parse(option.extra);
      } catch (error) {
        extra = null;
      }
      return {
        id: option.opcionId,
        value: option.valor,
        label: option.descripcion,
        order: option.orden,
        extra,
      };
    });
}

export default {
  SET_DOCUMENT_TYPES(state, payload) {
    state.documentTypes.list = payload
      .map((option) => ({
        id: option.opcionId,
        value: option.valor,
        label: option.descripcion,
        extra: JSON.parse(option.extra)
      }));
  },
  SET_DOCUMENT_TYPES_LOADING(state, payload) {
    state.documentTypes.loading = payload;
  },
  SET_DOCUMENT_PROCESS(state, payload) {
    state.documentProcess.list = payload
      .map((option) => ({
        id: option.opcionId,
        value: option.valor,
        label: option.descripcion,
        extra: JSON.parse(option.extra)
      }));
  },
  SET_DOCUMENT_PROCESS_LOADING(state, payload) {
    state.documentProcess.loading = payload;
  },
  SET_DOCUMENT_SUBPROCESS(state, payload) {
    state.documentSubProcess.list = payload
      .map((option) => ({
        id: option.opcionId,
        value: option.valor,
        label: option.descripcion,
        extra: JSON.parse(option.extra)
      }));
  },
  SET_DOCUMENT_SUBPROCESS_LOADING(state, payload) {
    state.documentSubProcess.loading = payload;
  },
  SET_DOCUMENT_TYPES_EXTERNALS(state, payload) {
    state.documentTypesExternals.list = [];
    state.documentTypesExternals.list = payload
      .map((option) => ({
        id: option.opcionId,
        value: option.valor,
        label: option.descripcion,
        extra: JSON.parse(option.extra)
      }));
  },
  SET_DOCUMENT_TYPES_EXTERNALS_LOADING(state, payload) {
    state.documentTypesExternals.loading = payload;
  },
  SET_DOCUMENTS(state, payload) {
    state.documents.list = payload
      .map((option) => ({
        id: option.opcionId,
        value: option.valor,
        label: option.descripcion,
        extra: JSON.parse(option.extra)
      }));
  },
  SET_DOCUMENTS_LOADING(state, payload) {
    state.documents.loading = payload;
  },
  SET_ALL_DOCUMENTS(state, payload) {
    state.allDocuments.list = payload
      .map((option) => ({
        id: option.opcionId,
        value: option.valor,
        label: option.descripcion,
        groupId: option.grupoId,
        deshabilitado: option.deshabilitado,
        extra: JSON.parse(option.extra)
      }));
  },
  SET_ALL_DOCUMENTS_LOADING(state, payload) {
    state.allDocuments.loading = payload;
  },
  SET_INSTITUTION_TYPES(state, payload) {
    state.institutionTypes.list = payload
      .map((option) => ({
        id: option.opcionId,
        value: option.valor,
        label: option.descripcion
      }));
  },
  SET_INSTITUTION_TYPES_LOADING(state, payload) {
    state.institutionTypes.loading = payload;
  },
  SET_INSTITUTIONS(state, payload) {
    state.institutions.list = payload
      .map((option) => ({
        id: option.opcionId,
        value: option.valor,
        label: option.descripcion
      }));
  },
  SET_INSTITUTIONS_LOADING(state, payload) {
    state.institutions.loading = payload;
  },
  SET_SUBJECTS(state, payload) {
    state.subjects.type = payload.type;

    switch (payload.type) {
      case 'unidades': {
        state.subjects.list = payload.list.map((option) => ({
          id: option.id,
          value: option.id,
          label: option.nombre
        }));
        break;
      }
      case 'oficinas': {
        state.subjects.list = payload.list.map((option) => ({
          id: option.id,
          value: option.id,
          label: option.nombre
        }));
        break;
      }
      case 'docDigital': {
        // TODO: test form with this case
        state.subjects.list = payload.list.map((option) => ({
          id: option.opcionId,
          value: option.valor,
          label: option.descripcion
        }));
        break;
      }
      case 'ministerios': {
        // TODO: test form with this case
        state.subjects.list = payload.list.map((option) => ({
          id: option.opcionId,
          value: option.valor,
          label: option.descripcion
        }));
        break;
      }
      default: {
        state.subjects.list = [];
        break;
      }
    }
  },
  SET_SUBJECTS_LOADING(state, payload) {
    state.subjects.loading = payload;
  },
  SET_INSTITUTIONS_DOC_DIGITAL_LOADING(state, payload) {
    state.institutionsDocDigital.loading = payload;
  },
  SET_USER_DOC_DIGITAL_LOADING(state, payload) {
    state.usersDocDigital.loading = payload;
  },
  SET_INSTITUTIONS_DOC_DIGITAL(state, payload) {
    state.institutionsDocDigital.list = payload
      .map((option) => ({
        id: option.opcionId,
        value: option.valor,
        label: option.descripcion,
        order: option.orden
      }));
  },
  SET_USER_DOC_DIGITAL(state, payload) {
    state.usersDocDigital.list = payload
      .map((option) => ({
        id: option.usuarioId,
        value: option.usuarioId.toString(),
        label: option.usuarioNombre,
        extra: {
          run: option.usuarioRun,
          email: option.usuarioEmail,
          position: option.usuarioCargo,
          entityId: option.entidadId,
          entityName: option.entidadNombre,
          organismId: option.organismoId,
          organismName: option.organismoNombre
        }
      }));
  },
  SET_GROUPS(state, payload) {
    state.groups.list = payload
      .map((option) => ({
        id: option.id,
        value: option.id,
        label: option.nombre,
        isOffice: option.esOficina || 'N',
        isDivision: option.esDivision || 'N',
        padreId: option.padreId || '',
        type: option.tipo,
        code: option.codigo
      }));
  },
  SET_GROUPS_LOADING(state, payload) {
    state.groups.loading = payload;
  },
  SET_APROVALS(state, payload) {
    state.aprovals.list = payload
      .map((option) => ({
        id: option.id,
        value: option.id,
        name: option.nombre,
        label: option.descripcion
      }));
  },
  SET_APROVALS_LOADING(state, payload) {
    state.aprovals.loading = payload;
  },
  SET_OFFICES(state, payload) {
    state.offices.list = payload
      .map((option) => ({
        id: option.id,
        value: option.id,
        label: option.nombre,
        isOffice: option.esOficina || 'N',
        hasLead: option.tieneLider || 'N',
        users: parseInt(option.cantidadUsuarios, 10),
        type: option.tipo,
        regionId: option.regionId,
        regionName: option.regionNombre,
        serviceId: option.servicioId,
        serviceName: option.servicioNombre
      }));
  },
  SET_OFFICES_LOADING(state, payload) {
    state.offices.loading = payload;
  },
  SET_GROUP_USERS(state, payload) {
    state.groupUsers.list = payload
      .map((option) => ({
        id: option.id,
        value: option.id,
        label: option.nombre,
        email: option.correo,
        position: option.cargo
      }));
  },
  SET_GROUP_USERS_LOADING(state, payload) {
    state.groupUsers.loading = payload;
  },
  SET_ACTIVITIES(state, payload) {
    state.activities.list = payload
      .map((option) => ({
        id: option.opcionId,
        value: option.valor,
        label: option.descripcion
      }));
  },
  SET_ACTIVITIES_LOADING(state, payload) {
    state.activities.loading = payload;
  },
  SET_ACTIVITY_STATES(state, payload) {
    state.activityStates.list = payload
      .map((option) => ({
        id: option.opcionId,
        value: option.valor,
        label: option.descripcion
      }));
  },
  SET_ACTIVITY_STATES_LOADING(state, payload) {
    state.activityStates.loading = payload;
  },
  SET_USER_GROUPS(state, payload) {
    state.userGroups.list = payload
      .map((option) => ({
        id: option.id,
        value: option.id,
        label: option.nombre,
        parentId: option.padreId || '',
        isOffice: option.esOficina || 'N',
        type: option.tipo
      }));
  },
  SET_USER_GROUPS_LOADING(state, payload) {
    state.userGroups.loading = payload;
  },
  SET_LIST_LOADING(state, { target, value }) {
    state[target].loading = value;
  },
  SET_LIST_INDEXED(
    state,
    {
      target,
      value,
      id = 'id',
      indexedBy = 'value'
    }
  ) {
    state[target] = {
      ...state[target],
      [indexedBy]: value.reduce((index, element) => ({
        ...index,
        // TODO: setup de mapper using the target property
        [element[id]]: {
          id: element.id,
          value: element.id,
          label: element.nombre,
          iut: element.iut,
          position: element.cargo,
          rol: element.rol,
          email: element.correo
        }
      }), state[target][indexedBy])
    };
  },
  RESET_USERS(state) {
    state.users = { value: {}, loading: false };
  },
  SET_PROFILES_INDEXED(
    state,
    {
      target,
      value,
      id = 'idPerfil',
      indexedBy = 'value'
    }
  ) {
    state[target] = {
      ...state[target],
      [indexedBy]: value.reduce((index, element) => ({
        ...index,
        [element[id]]: {
          id: element.idPerfil,
          value: element.idPerfil,
          label: element.nombre,
          iut: element.idPerfil,
          description: element.descripcion
        }
      }), state[target][indexedBy])
    };
  },
  REMOVE_ITEM_FROM_INDEXED_LIST(
    state,
    {
      target,
      indexedBy = 'value',
      elementId
    }
  ) {
    const { [elementId]: ignored, ...otherElements } = state[target][indexedBy];
    state[target][indexedBy] = otherElements;
  },
  SET_LIST(
    state,
    {
      target,
      value
    }
  ) {
    state[target].list = value.map((element) => ({
      id: element.id,
      value: element.id,
      label: element.nombre
    }));
  },
  SET_SANITARY_COMPANIES(state, payload) {
    state.sanitaryCompanies.list = payload
      .map((option) => ({
        id: option.opcionId,
        value: option.valor,
        label: option.descripcion,
        extra: JSON.parse(option.extra)
      }));
  },
  SET_SANITARY_COMPANIES_LOADING(state, payload) {
    state.sanitaryCompanies.loading = payload;
  },
  SET_ISAPRES(state, payload) {
    state.isapres.list = mapOptions(payload);
  },
  SET_ISAPRES_LOADING(state, payload) {
    state.isapres.loading = payload;
  },
  SET_AFPS(state, payload) {
    state.afps.list = mapOptions(payload);
  },
  SET_AFPS_LOADING(state, payload) {
    state.afps.loading = payload;
  },
  SET_BANKS(state, payload) {
    state.banks.list = mapOptions(payload);
  },
  SET_BANKS_LOADING(state, payload) {
    state.banks.loading = payload;
  },
  SET_ACADEMIC_DEGREE(state, payload) {
    state.academicDegree.list = mapOptions(payload);
  },
  SET_ACADEMIC_DEGREE_LOADING(state, payload) {
    state.academicDegree.loading = payload;
  },
  SET_NATIONALITY(state, payload) {
    state.nationality.list = mapOptions(payload);
  },
  SET_NATIONALITY_LOADING(state, payload) {
    state.nationality.loading = payload;
  },
  SET_TITLE(state, payload) {
    state.title.list = mapOptions(payload);
  },
  SET_TITLE_LOADING(state, payload) {
    state.title.loading = payload;
  },
  SET_SUBJECT(state, payload) {
    state.subject.list = mapOptions(payload);
  },
  SET_SUBJECT_LOADING(state, payload) {
    state.subject.loading = payload;
  },
  SET_CAREER(state, payload) {
    state.career.list = mapOptions(payload);
  },
  SET_CAREER_LOADING(state, payload) {
    state.career.loading = payload;
  },
  SET_UNIVERSITY(state, payload) {
    state.university.list = mapOptions(payload);
  },
  SET_UNIVERSITY_LOADING(state, payload) {
    state.university.loading = payload;
  },
  SET_CITY(state, payload) {
    state.city.list = mapOptions(payload);
  },
  SET_CITY_LOADING(state, payload) {
    state.city.loading = payload;
  },
  SET_RESPONSIBILITY_CENTER(state, payload) {
    state.responsibilityCenter.list = mapOptions(payload);
  },
  SET_RESPONSIBILITY_CENTER_LOADING(state, payload) {
    state.responsibilityCenter.loading = payload;
  },
  SET_PAYMENT_PERIOD(state, payload) {
    state.paymentPeriod.list = mapOptions(payload);
  },
  SET_PAYMENT_PERIOD_LOADING(state, payload) {
    state.paymentPeriod.loading = payload;
  },
  SET_CONTRACT_PAYMENT_PERIOD(state, payload) {
    state.contractPaymentPeriod.list = mapOptions(payload);
  },
  SET_CONTRACT_PAYMENT_PERIOD_LOADING(state, payload) {
    state.contractPaymentPeriod.loading = payload;
  },
  SET_PERIOD(state, payload) {
    state.period.list = mapOptions(payload);
  },
  SET_PERIOD_LOADING(state, payload) {
    state.period.loading = payload;
  },
  SET_HEAD_OF_CAREER(state, payload) {
    state.headOfCareer.list = mapOptions(payload);
  },
  SET_HEAD_OF_CAREER_LOADING(state, payload) {
    state.headOfCareer.loading = payload;
  },
  SET_ADMINISTRATIVE_SUPPORT(state, payload) {
    state.administrativeSupport.list = mapOptions(payload);
  },
  SET_ADMINISTRATIVE_SUPPORT_LOADING(state, payload) {
    state.administrativeSupport.loading = payload;
  },
  SET_ADMINISTRATIVE_RESPONSIBLE(state, payload) {
    state.administrativeResponsible.list = mapOptions(payload);
  },
  SET_ADMINISTRATIVE_RESPONSIBLE_LOADING(state, payload) {
    state.administrativeResponsible.loading = payload;
  },
  SET_SCH_ATTACHMENTS_SELECTORS(state, payload) {
    state.schAttachmentsSelectors.list = mapOptions(payload);
  },
  SET_SCH_ATTACHMENTS_SELECTORS_LOADING(state, payload) {
    state.schAttachmentsSelectors.loading = payload;
  },
  SET_GRC_ATTACHMENTS_SELECTORS(state, payload) {
    state.grcAttachmentsSelectors.list = mapOptions(payload);
  },
  SET_GRC_ATTACHMENTS_SELECTORS_LOADING(state, payload) {
    state.grcAttachmentsSelectors.loading = payload;
  },
  SET_SCF_ATTACHMENTS_SELECTORS_LOADING(state, payload) {
    state.scfAttachmentsSelectors.loading = payload;
  },
  SET_SCF_ATTACHMENTS_SELECTORS(state, payload) {
    state.scfAttachmentsSelectors.list = mapOptions(payload);
  },
  SET_ACT_ATTACHMENTS_SELECTORS(state, payload) {
    state.actAttachmentsSelectors.list = mapOptions(payload);
  },
  SET_ACT_ATTACHMENTS_SELECTORS_LOADING(state, payload) {
    state.actAttachmentsSelectors.loading = payload;
  },
};
